import { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Yandan açılan panel (drawer) — mobil menyu üçün.
 *
 * DİQQƏT: panel mütləq document.body-yə portal ilə render olunur.
 * Səbəb: valideyn başlıqda `backdrop-blur` var və CSS-də backdrop-filter
 * "containing block" yaradır — daxilindəki `position: fixed` element
 * viewport-a görə yox, başlığa görə yerləşir (panel 56px hündürlükdə
 * sıxılır, keçidlər görünmür). Portal bu problemi tam aradan qaldırır.
 *
 * Açıq olanda arxa fon scroll-u kilidlənir; Esc və fona klik bağlayır.
 */
const Drawer = ({ open, onClose, children, side = "right", labelledBy }) => {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  const closedTransform = side === "right" ? "translate-x-full" : "-translate-x-full";
  const sidePosition = side === "right" ? "right-0" : "left-0";
  const sideRadius = side === "right" ? "rounded-l-3xl" : "rounded-r-3xl";

  return createPortal(
    <>
      {/* Fon */}
      <div
        onClick={onClose}
        aria-hidden="true"
        className={`fixed inset-0 z-[60] bg-slate-950/60 backdrop-blur-sm transition-opacity duration-300 ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      />

      {/* Panel */}
      <aside
        role="dialog"
        aria-modal="true"
        aria-hidden={!open}
        aria-labelledby={labelledBy}
        className={`drawer-panel fixed top-0 ${sidePosition} z-[70] w-[82%] max-w-xs ${sideRadius}
          bg-gradient-to-b from-indigo-700 to-purple-800 shadow-2xl
          transition-transform duration-300 ease-out will-change-transform
          flex flex-col ${
            open ? "translate-x-0" : `${closedTransform} pointer-events-none`
          }`}
      >
        {children}
      </aside>
    </>,
    document.body
  );
};

export default Drawer;
